import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { Panel } from 'primereact/panel';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { BomCostingService } from '../../service/BomCostingService';
import CostElement from '../../models/CostElement';
import Factory from '../../models/Factory';
import FormulaOption from "../../models/FormulaOption";
import RateDefault from '../../models/RateDefault';
import { InputNumber } from 'primereact/inputnumber';
import StyleCostConfiguration from '../../models/StyleCostConfiguration';
import { Toast } from "primereact/toast";
import { DataTable, DataTableFilterEvent } from 'primereact/datatable';
import { Column, ColumnEvent } from 'primereact/column';
import React from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { OverlayPanel } from 'primereact/overlaypanel';
import ValueRate from '../../models/ValueRate';
import TwoValueRate from '../../models/TwoValueRate';
import ThreeValueRate from '../../models/ThreeValueRate';
import WorkCenter from '../../models/WorkCenter';
import { Calendar } from 'primereact/calendar';
import { Card } from 'primereact/card';
import { useMsal } from "@azure/msal-react";
import { Link, useParams } from 'react-router-dom';
import { FormEvent } from 'primereact/ts-helpers';

const StyleCostElements = () => {
    const defaultValues: StyleCostConfiguration = {
        id: 0,
        styleCd: '',
        factoryId: 0,
        sapReference:'',
        costElementId: 0,
        costElementDescription:'',
        formulaOptionId: null,
        formulaOptionName:'',
        letterSize: null,
        numberOfColors: null,
        color: null,
        orderMin: null,
        orderMax: null,
        rate: 0.0,
        effectiveDate: null,
        expirationDate: null,
        minChargeUnit: null,
        minChargeCostElement: null,
        workCenterId: null,
        workCenterCode:'',
        minutes: null,
        updateDate: null,
        updateUser: null
    };

    type FieldNames = 'costElementId' | 'factoryId' | 'formulaOptionId' | 'letterSize' | 'numberOfColors' | 'color' | 'orderMin' | 'orderMax' | 'rate' | 'effectiveDate' | 'expirationDate' | 'minChargeUnit' | 'minChargeCostElement' | 'workCenterId' | 'minutes';
    const fieldOrder: FieldNames[] = ['costElementId', 'factoryId', 'formulaOptionId', 'letterSize', 'numberOfColors', 'color', 'orderMin', 'orderMax', 'rate', 'effectiveDate', 'expirationDate', 'minChargeUnit', 'minChargeCostElement', 'workCenterId', 'minutes'];

    const isNew = useRef(false);
    const toastRD = useRef<any>(null);
    const formCE = useForm();
    const op = useRef<OverlayPanel>(null);
    const { styleCode } = useParams();

    const errorsCE = formCE.formState.errors;

    const [loadingStyleCostConfiguration, setLoadingStyleCostConfiguration] = useState(true);
    const [loadingRateDefaultsMaterialGroup, setLoadingRateDefaultsMaterialGroup] = useState(true);
    const [deleteDialogCE, setDeleteDialogCE] = useState(false);

    const [styleCostConfiguration, setStyleCostConfiguration] = useState<StyleCostConfiguration>(defaultValues);
    const [styleCostConfigurations, setStyleCostConfigurations] = useState<StyleCostConfiguration[]>([]);
    const [rateDefaultsMaterialGroup, setRateDefaultsMaterialGroup] = useState<RateDefault[]>([]);

    const [costElements, setCostElements] = useState<CostElement[]>([]);
    const [workCenters, setWorkCenters] = useState<WorkCenter[]>([]);
    const [formulaOptions, setFormulaOptions] = useState<FormulaOption[]>([]);
    const [factories, setFactories] = useState<Factory[]>([]);
    const [rateDefaults, setRateDefaults] = useState<RateDefault[]>([]);
    const [defaultListSizeColors, setDefaultListSizeColors] = useState<ValueRate[]>([]);
    const [defaultListOrderMinMax, setDefaultListOrderMinMax] = useState<TwoValueRate[]>([]);
    const [defaultListOrderMinMaxColor, setDefaultListOrderMinMaxColor] = useState<ThreeValueRate[]>([]);


    const [selectedFormula, setSelectedFormula] = useState<number | null>(null);
    const [selectedCostElement, setSelectedCostElement] = useState<number | null>(null);
    const [selectedFactory, setSelectedFactory] = useState<number | null>(null);
    const [selectedSizes, setSelectedSizes] = useState<ValueRate[] | null>(null);
    const [selectedColors, setSelectedColors] = useState<ValueRate[] | null>(null);
    const [selectedOrderMinMax, setSelectedOrderMinMax] = useState<TwoValueRate[] | null>(null);
    const [selectedOrderMinMaxColor, setSelectedOrderMinMaxColor] = useState<ThreeValueRate[] | null>(null);
    const [selectedRateDefault, setSelectedRateDefault] = useState<RateDefault | null>(null);
    
    const [globalFilterRD, setGlobalFilterRD] = useState('');
    const [globalFilterCE, setGlobalFilterCE] = useState('');
    const dtRD = useRef<any>(null);
    const dtCE = useRef<any>(null);
    const { accounts } = useMsal();

    useEffect(() => {
        if (!styleCode) { return; }

        BomCostingService.getAllRateDefaults().then(data => setRateDefaults(data));
        BomCostingService.getAllCostElements().then((data: CostElement[]) => setCostElements(data));
        BomCostingService.getAllWorkCenters().then((data: WorkCenter[]) => setWorkCenters(data));
        BomCostingService.getAllFactories().then((data: Factory[]) => setFactories(data));
        BomCostingService.getAllFormulaOptions().then((data: FormulaOption[]) => setFormulaOptions(data));
        BomCostingService.getAllStyleCostConfigurationsByStyle(styleCode).then((data: StyleCostConfiguration[]) => {
            setStyleCostConfigurations(data); setLoadingStyleCostConfiguration(false);             
        });
        BomCostingService.getRateDefaultByMaterialGroup(styleCode).then((data: RateDefault[]) => {
            setRateDefaultsMaterialGroup(data); setLoadingRateDefaultsMaterialGroup(false);
        });

    }, [styleCode]);

    const factoryIdBodyTemplate = (rowData: StyleCostConfiguration) => { return factories.find(wc => wc.id === rowData.factoryId)?.sapReference; }
    const costElementIdBodyTemplate = (rowData: StyleCostConfiguration) => { return costElements.find(wc => wc.id === rowData.costElementId)?.description; }
    const formulaOptionIdBodyTemplate = (rowData: StyleCostConfiguration) => { return formulaOptions.find(wc => wc.id === rowData.formulaOptionId)?.optionName; }
    const letterSizeBodyTemplate = (rowData: StyleCostConfiguration) => { return rowData.letterSize }
    const numberOfColorsBodyTemplate = (rowData: StyleCostConfiguration) => { return rowData.numberOfColors }
    const colorBodyTemplate = (rowData: StyleCostConfiguration) => { return rowData.color }
    const orderMinBodyTemplate = (rowData: StyleCostConfiguration) => { return rowData.orderMin }
    const orderMaxBodyTemplate = (rowData: StyleCostConfiguration) => { return rowData.orderMax }
    const rateBodyTemplate = (rowData: StyleCostConfiguration) => { return rowData.rate }
    const effectiveDateBodyTemplate = (rowData: StyleCostConfiguration) => { return rowData.effectiveDate }
    const expirationDateBodyTemplate = (rowData: StyleCostConfiguration) => { return rowData.expirationDate }
    const minChargeUnitBodyTemplate = (rowData: StyleCostConfiguration) => { return rowData.minChargeUnit }
    const minChargeCostElementBodyTemplate = (rowData: StyleCostConfiguration) => { return rowData.minChargeCostElement }
    const workCenterIdBodyTemplate = (rowData: StyleCostConfiguration) => { return workCenters.find(wc => wc.id === rowData.workCenterId)?.code; }
    const minutesBodyTemplate = (rowData: StyleCostConfiguration) => { return rowData.minutes }

    const costElementIdTemplateRD = (rowData: RateDefault) => costElements.find(ce => ce.id === rowData.costElementId)?.description;
    const formulaOptionIdTemplateRD = (rowData: RateDefault) => formulaOptions.find(fo => fo.id === rowData.formulaOptionId)?.optionName;
    const factoryIdTemplateRD = (rowData: RateDefault) => factories.find(fa => fa.id === rowData.factoryId)?.sapReference;
    const letterSizeTemplateRD = (rowData: RateDefault) => rowData.letterSize;
    const numberOfColorsTemplateRD = (rowData: RateDefault) => rowData.numberOfColors;
    const colorTemplateRD = (rowData: RateDefault) => rowData.color;
    const orderMinTemplateRD = (rowData: RateDefault) => rowData.orderMin;
    const orderMaxTemplateRD = (rowData: RateDefault) => rowData.orderMax;
    const rateTemplateRD = (rowData: RateDefault) => rowData.rate;
    const effectiveDateTemplateRD = (rowData: RateDefault) => rowData.effectiveDate;
    const expirationDateTemplateRD = (rowData: RateDefault) => rowData.expirationDate;
    const minChargeUnitBodyTemplateRD = (rowData: RateDefault) => { return rowData.minChargeUnit }
    const minChargeCostElementBodyTemplateRD = (rowData: RateDefault) => { return rowData.minChargeCostElement }
    const workCenterIdBodyTemplateRD = (rowData: RateDefault) => { return workCenters.find(wc => wc.id === rowData.workCenterId)?.code; }
    const minutesBodyTemplateRD = (rowData: RateDefault) => { return rowData.minutes }

    const addNew = () => {
        const maxId = defaultListSizeColors.length > 0 ? Math.max(...defaultListSizeColors.map(item => item.id)) : 0;
        const newObject = { id: maxId + 1, value: 0, rate: 0 };
        setDefaultListSizeColors([...defaultListSizeColors, newObject]);
    }

    const addNewTwo = () => {
        const maxId = defaultListOrderMinMax.length > 0 ? Math.max(...defaultListOrderMinMax.map(item => item.id)) : 0;
        const newObject = { id: maxId + 1, min: 0, max: 0, rate: 0 };
        setDefaultListOrderMinMax([...defaultListOrderMinMax, newObject]);
    }

    const addNewThree = () => {
        const maxId = defaultListOrderMinMaxColor.length > 0 ? Math.max(...defaultListOrderMinMaxColor.map(item => item.id)) : 0;
        const newObject = { id: maxId + 1, color: '', min: 0, max: 0, rate: 0 };
        setDefaultListOrderMinMaxColor([...defaultListOrderMinMaxColor, newObject]);
    }

    const clearNew = () => {
        formCE.reset();
        resetFollowingFields('costElementId');
        setSelectedCostElement(null);
        setSelectedSizes([]);
        setSelectedColors([]);
        setSelectedOrderMinMax([]);
        setSelectedOrderMinMaxColor([]);
        setDefaultListSizeColors([]);
        setDefaultListOrderMinMax([]);
        setDefaultListOrderMinMaxColor([]);
    };

    const newCostElement = (data: any) => {
        if (!styleCode) { return; }
        isNew.current = true;
        let _value = { ...styleCostConfiguration };
        _value.id = 0;
        _value.styleCd = styleCode;
        _value.factoryId = data.factoryId;
        _value.costElementId = data.costElementId;
        _value.formulaOptionId = data.formulaOptionId;
        _value.letterSize = data.letterSize;
        _value.numberOfColors = data.numberOfColors;
        _value.color = data.color;
        _value.orderMin = data.orderMin;
        _value.orderMax = data.orderMax;
        _value.rate = data.rate;
        _value.effectiveDate = data.effectiveDate;
        _value.expirationDate = data.expirationDate;
        _value.minChargeUnit = data.minChargeUnit;
        _value.minChargeCostElement = data.minChargeCostElement;
        _value.minutes = data.minutes;
        return _value;
    }

    const onSubmitCostElements = async (data: any) => {
        if (!styleCode) { return; }
        // Find an identical object based on style, cost element, plant and effective date
        const identicalRateDefault = findIdenticalRateDefault(data);

        // If it is identical then return duplicated object
        if (identicalRateDefault) {
            toastRD.current.show({ severity: 'error', summary: 'Exception', detail: 'There is an identical cost element with the same effective date', life: 3000 });
            return;
        }

        // Check if the new entry's effective date falls within an existing active date range
        const activeElementConflict = styleCostConfigurations.some(element =>
            element.styleCd === styleCode &&
            element.factoryId === data.factoryId &&
            element.costElementId === data.costElementId &&
            element.effectiveDate &&
            new Date(data.effectiveDate) >= new Date(element.effectiveDate) &&
            new Date(data.effectiveDate) <= (element.expirationDate ? new Date(element.expirationDate) : new Date())
        );

        // Return an error if there is a conflict
        if (activeElementConflict) {
            toastRD.current.show({ severity: 'error', summary: 'Exception', detail: 'Active rate exists within the specified date range', life: 3000 });
            return;
        }

        // Handle autoexpiration
        for (const element of styleCostConfigurations) {
            if (element.styleCd === styleCode &&
                element.factoryId === data.factoryId &&
                element.costElementId === data.costElementId &&
                !element.expirationDate) {

                const newEffectiveDate = new Date(data.effectiveDate);
                newEffectiveDate.setDate(newEffectiveDate.getDate() - 1);
                const adjustedExpirationDate = `${newEffectiveDate.getFullYear()}-${String(newEffectiveDate.getMonth() + 1).padStart(2, '0')}-${String(newEffectiveDate.getDate()).padStart(2, '0')}`;

                element.expirationDate = adjustedExpirationDate;
                await update(element);
                break;
            }
        }

        let _listValues = [...styleCostConfigurations];
        let savedData = null;
        switch (data.formulaOptionId) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 8:
                savedData = await save(newCostElement(data) ?? null);
                if (savedData) {
                    _listValues.push(savedData);
                    _listValues = _listValues.map(rd => ({
                        ...rd,
                        effectiveDate: rd.effectiveDate ? convertToISODateString(rd.effectiveDate) : '',
                        expirationDate: rd.expirationDate ? convertToISODateString(rd.expirationDate) : ''
                    }))
                }
                return setStyleCostConfigurations(_listValues);
            case 5:
            case 10:
                if (selectedSizes && selectedSizes.length > 0) {
                    let _listValues = [...styleCostConfigurations];

                    for (const item of selectedSizes) {
                        const newData = {
                            ...data,
                            letterSize: item.value,
                            rate: item.rate
                        };

                        const savedData = await save(newCostElement(newData) ?? null);
                        if (savedData) {
                            _listValues.push(savedData);
                            _listValues = _listValues.map(rd => ({
                                ...rd,
                                effectiveDate: rd.effectiveDate ? convertToISODateString(rd.effectiveDate) : '',
                                expirationDate: rd.expirationDate ? convertToISODateString(rd.expirationDate) : ''
                            }))
                        }
                    }

                    setStyleCostConfigurations(_listValues);
                } else {
                    toastRD.current.show({ severity: 'error', summary: 'Exception', detail: 'You need to select at least one size. Not saving.', life: 3000 });
                    return;
                }
                return;
            case 6:
                if (selectedColors && selectedColors.length > 0) {
                    let _listValues = [...styleCostConfigurations];

                    for (const item of selectedColors) {
                        const newData = {
                            ...data,
                            numberOfColors: item.value,
                            rate: item.rate
                        };
                        const savedData = await save(newCostElement(newData) ?? null);
                        if (savedData) {
                            _listValues.push(savedData);
                            _listValues = _listValues.map(rd => ({
                                ...rd,
                                effectiveDate: rd.effectiveDate ? convertToISODateString(rd.effectiveDate) : '',
                                expirationDate: rd.expirationDate ? convertToISODateString(rd.expirationDate) : ''
                            }))
                        }
                    }

                    setStyleCostConfigurations(_listValues);
                } else {
                    toastRD.current.show({ severity: 'error', summary: 'Exception', detail: 'You need to select at least one number of colors. Not saving.', life: 3000 });
                    return;
                }
                return;
            case 7:
                if (selectedOrderMinMax && selectedOrderMinMax.length > 0) {
                    let _listValues = [...styleCostConfigurations];

                    for (const item of selectedOrderMinMax) {
                        const newData = {
                            ...data,
                            orderMin: item.min,
                            orderMax: item.max,
                            rate: item.rate
                        };
                        const savedData = await save(newCostElement(newData) ?? null);
                        if (savedData) {
                            _listValues.push(savedData);
                            _listValues = _listValues.map(rd => ({
                                ...rd,
                                effectiveDate: rd.effectiveDate ? convertToISODateString(rd.effectiveDate) : '',
                                expirationDate: rd.expirationDate ? convertToISODateString(rd.expirationDate) : ''
                            }))
                        }
                    }

                    setStyleCostConfigurations(_listValues);
                } else {
                    toastRD.current.show({ severity: 'error', summary: 'Exception', detail: 'You need to select at least one order quantity. Not saving.', life: 3000 });
                    return;
                }
                return;
            case 9:
                if (selectedOrderMinMaxColor && selectedOrderMinMaxColor.length > 0) {
                    let _listValues = [...styleCostConfigurations];

                    for (const item of selectedOrderMinMaxColor) {
                        const newData = {
                            ...data,
                            color: item.color,
                            orderMin: item.min,
                            orderMax: item.max,
                            rate: item.rate
                        };
                        const savedData = await save(newCostElement(newData) ?? null);
                        if (savedData) {
                            _listValues.push(savedData);
                            _listValues = _listValues.map(rd => ({
                                ...rd,
                                effectiveDate: rd.effectiveDate ? convertToISODateString(rd.effectiveDate) : '',
                                expirationDate: rd.expirationDate ? convertToISODateString(rd.expirationDate) : ''
                            }))

                        }
                    }

                    setStyleCostConfigurations(_listValues);
                } else {
                    toastRD.current.show({ severity: 'error', summary: 'Exception', detail: 'You need to select at least one color and order quantity. Not saving.', life: 3000 });
                    return;
                }
                return;
            default:
                savedData = await save(newCostElement(data) ?? null);
                if (savedData) {
                    _listValues.push(savedData);
                    _listValues = _listValues.map(rd => ({
                        ...rd,
                        effectiveDate: rd.effectiveDate ? convertToISODateString(rd.effectiveDate) : '',
                        expirationDate: rd.expirationDate ? convertToISODateString(rd.expirationDate) : ''
                    }))

                }
                return setStyleCostConfigurations(_listValues);
        }


    };

    const save = async (value: StyleCostConfiguration | null): Promise<StyleCostConfiguration | null> => {
        if (!value) { return null; }

        if (accounts[0]) {
            value.updateDate = new Date().toISOString();
            value.updateUser = accounts[0].username;
        }

        try {
            const data = await BomCostingService.addStyleCostConfiguration(value);
            if (data) {
                toastRD.current.show({ severity: 'success', summary: 'Successful', detail: 'Cost element added to style', life: 3000 });

                clearNew();
                return data;
            } else {
                toastRD.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed adding Cost element to style', life: 3000 });
                return null;
            }
        } catch (error) {
            toastRD.current.show({ severity: 'error', summary: 'Exception', detail: 'An exception occurred while adding Cost element to style', life: 3000 });
            return null;
        }
    };

    const update = (value: StyleCostConfiguration): Promise<void> => {
        if (accounts[0]) {
            value.updateDate = new Date().toISOString();
            value.updateUser = accounts[0].username;
        }
        return new Promise((resolve, reject) => {
            let _listValues = [...styleCostConfigurations];
            BomCostingService.updateStyleCostConfiguration(value).then((data) => {
                if (data) {
                    let index = _listValues.findIndex(v => v.id === value.id);
                    _listValues[index] = value;
                    _listValues = _listValues.map(rd => ({
                        ...rd,
                        effectiveDate: rd.effectiveDate ? convertToISODateString(rd.effectiveDate) : '',
                        expirationDate: rd.expirationDate ? convertToISODateString(rd.expirationDate) : ''
                    }))
                    setStyleCostConfigurations(_listValues);
                    resolve();
                } else {
                    toastRD.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Style Costing', life: 3000 });
                    reject(new Error("Failed to Update Style Costing"));
                }
            });
        });
    }

    function convertToISODateString(dateString: string): string {
        const isoDate = new Date(dateString);

        const formattedDate = isoDate.toISOString().split('T')[0];

        return formattedDate;
    }

    const getErrorMessage = (name: string) => {
        return errorsCE[name] ? <small className="p-error">{(errorsCE[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const confirmDeleteCE = (value: StyleCostConfiguration) => {
        setStyleCostConfiguration(value);
        setDeleteDialogCE(true);
    }

    const rowEditorTemplate = (rowData: StyleCostConfiguration, props: any) => {
        return (
            <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDeleteCE(rowData)} to={''}></Link>
        );
    }

    const hideDeleteDialogCE = () => {
        setDeleteDialogCE(false);
    };

    const deleteRow = () => {
        let _styleCostConfigurations = styleCostConfigurations.filter((val) => val.id !== styleCostConfiguration.id);
        BomCostingService.deleteStyleCostConfiguration(styleCostConfiguration.id).then((data: boolean) => {
            if (data) {
                setStyleCostConfigurations(_styleCostConfigurations);
                setDeleteDialogCE(false);
                setStyleCostConfiguration(defaultValues);
                toastRD.current.show({ severity: 'success', summary: 'Successful', detail: 'Deleted', life: 3000 });
            } else {
                toastRD.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to remove', life: 3000 });
            }
        });

    };

    const deleteDialogFooterCE = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" outlined onClick={hideDeleteDialogCE} />
            <Button label="Yes" icon="pi pi-check" severity="danger" onClick={deleteRow} />
        </React.Fragment>
    );

    const resetFollowingFields = (changedField: FieldNames) => {
        const fieldIndex = fieldOrder.indexOf(changedField);

        if (fieldIndex === -1) {
            return;
        }

        const fieldsToReset = fieldOrder.slice(fieldIndex + 1);

        fieldsToReset.forEach((field) => {
            if (field === 'formulaOptionId') {
                setSelectedFormula(null);
            }
            if (field === 'factoryId') {
                setSelectedFactory(null);
            }

            setSelectedSizes([]);
            setSelectedColors([]);
            setSelectedOrderMinMax([]);
            setSelectedOrderMinMaxColor([])
            setDefaultListSizeColors([]);
            setDefaultListOrderMinMax([]);
            setDefaultListOrderMinMaxColor([]);

            formCE.setValue(field, null);
        });
    };

    const findIdenticalRateDefault = (_value: StyleCostConfiguration): StyleCostConfiguration | undefined => {
        let tempDate = new Date(_value.effectiveDate ? _value.effectiveDate : '');
        const effectiveDate = tempDate.toISOString().split('T')[0];
        switch (_value.formulaOptionId) {
            case 0:
            case 1:
            case 2:
            case 3:
            case 8:
            case 4:
                return styleCostConfigurations.find((t: any) => {
                    return t.styleCd === styleCode &&
                        t.factoryId === _value.factoryId &&
                        t.costElementId === _value.costElementId &&
                        t.effectiveDate === effectiveDate
                });
            case 5:
            case 10:
                return styleCostConfigurations.find((t: any) => {
                    return t.styleCd === styleCode &&
                        t.factoryId === _value.factoryId &&
                        t.costElementId === _value.costElementId &&
                        (selectedSizes && selectedSizes.some(item => item.value === t.letterSize)) &&
                        t.effectiveDate === effectiveDate
                });
            case 6:
                return styleCostConfigurations.find((t: any) => {
                    return t.styleCd === styleCode &&
                        t.factoryId === _value.factoryId &&
                        t.costElementId === _value.costElementId &&
                        (selectedColors && selectedColors.some(item => item.value === t.numberOfColors)) &&
                        t.effectiveDate === effectiveDate
                });
            case 7:
                return styleCostConfigurations.find((t: any) => {
                    return t.styleCd === styleCode &&
                        t.factoryId === _value.factoryId &&
                        t.costElementId === _value.costElementId &&
                        (selectedOrderMinMax && selectedOrderMinMax.some(item => item.min === t.orderMin) && selectedOrderMinMax.some(item => item.max === t.orderMax)) &&
                        t.effectiveDate === effectiveDate
                });
            case 9:
                return styleCostConfigurations.find((t: any) => {
                    return t.styleCd === styleCode &&
                        t.factoryId === _value.factoryId &&
                        t.costElementId === _value.costElementId &&
                        (selectedOrderMinMaxColor && selectedOrderMinMaxColor.some(item => item.color === t.color) && selectedOrderMinMaxColor.some(item => item.min === t.orderMin) && selectedOrderMinMaxColor.some(item => item.max === t.orderMax)) &&
                        t.effectiveDate === effectiveDate
                });
            default:
                return undefined;
        }
    };

    const findBestRate = (formula: number | null, costElement: number | null, factory: number | null) => {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        const isValidDateRange = (rate: RateDefault): boolean => {
            const effectiveParts = rate.effectiveDate.split('-').map(Number);
            const effective = new Date(effectiveParts[0], effectiveParts[1] - 1, effectiveParts[2]);

            let expiration: Date | null = null;
            if (rate.expirationDate) {
                const expirationParts = rate.expirationDate.split('-').map(Number);
                expiration = new Date(expirationParts[0], expirationParts[1] - 1, expirationParts[2]);
            }

            return (effective <= currentDate) && (expiration ? expiration >= currentDate : true);
        };

        let listByFactoryAndMaterialGroup = null;
        let listByFactoryOnly = null;
        switch (formula) {
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 8:
                // Find the most specific rate based on factory and material group and date validity
                const byFactoryAndMaterialGroup = rateDefaults.find(
                    rate => rate.factoryId === factory && rate.costElementId === costElement && rate.formulaOptionId === formula && rate.materialGroupId !== null && isValidDateRange(rate)
                );

                if (byFactoryAndMaterialGroup) {
                    setSelectedRateDefault(byFactoryAndMaterialGroup);
                    formCE.setValue('rate', byFactoryAndMaterialGroup.rate);
                    return;
                }

                // If not found, try to find a rate by factory only and check its date validity
                const byFactoryOnly = rateDefaults.find(
                    rate => rate.factoryId === factory && rate.costElementId === costElement && rate.formulaOptionId === formula && isValidDateRange(rate)
                );

                if (byFactoryOnly) {
                    setSelectedRateDefault(byFactoryOnly);
                    formCE.setValue('rate', byFactoryOnly.rate);
                    return;
                }

                setSelectedRateDefault(null);
                return;
            case 5:
            case 10:
                listByFactoryAndMaterialGroup = rateDefaults.filter(
                    rate => rate.factoryId === factory && rate.costElementId === costElement && rate.formulaOptionId === formula && rate.materialGroupId !== null && isValidDateRange(rate)
                );

                if (listByFactoryAndMaterialGroup.length > 0) {
                    setDefaultListSizeColors(listByFactoryAndMaterialGroup.map(rate => ({
                        id: rate.id,
                        value: rate.letterSize as number,
                        rateDefault: rate.rate as number,
                        rate: rate.rate as number
                    })))
                    return;
                }

                listByFactoryOnly = rateDefaults.filter(
                    rate => rate.factoryId === factory && rate.costElementId === costElement && rate.formulaOptionId === formula && isValidDateRange(rate)
                );

                if (listByFactoryOnly.length > 0) {
                    setDefaultListSizeColors(listByFactoryOnly.map(rate => ({
                        id: rate.id,
                        value: rate.letterSize as number,
                        rateDefault: rate.rate as number,
                        rate: rate.rate as number
                    })))
                    return;
                }

                setDefaultListSizeColors([])
                return;
            case 6:
                listByFactoryAndMaterialGroup = rateDefaults.filter(
                    rate => rate.factoryId === factory && rate.costElementId === costElement && rate.formulaOptionId === formula && rate.materialGroupId !== null && isValidDateRange(rate)
                );

                if (listByFactoryAndMaterialGroup.length > 0) {
                    setDefaultListSizeColors(listByFactoryAndMaterialGroup.map(rate => ({
                        id: rate.id,
                        value: rate.numberOfColors as number,
                        rateDefault: rate.rate as number,
                        rate: rate.rate as number
                    })))
                    return;
                }

                listByFactoryOnly = rateDefaults.filter(
                    rate => rate.factoryId === factory && rate.costElementId === costElement && rate.formulaOptionId === formula && isValidDateRange(rate)
                );

                if (listByFactoryOnly.length > 0) {
                    setDefaultListSizeColors(listByFactoryOnly.map(rate => ({
                        id: rate.id,
                        value: rate.numberOfColors as number,
                        rateDefault: rate.rate as number,
                        rate: rate.rate as number
                    })))
                    return;
                }

                setDefaultListSizeColors([])
                return;
            case 7:
                listByFactoryAndMaterialGroup = rateDefaults.filter(
                    rate => rate.factoryId === factory && rate.costElementId === costElement && rate.formulaOptionId === formula && rate.materialGroupId !== null && isValidDateRange(rate)
                );

                if (listByFactoryAndMaterialGroup.length > 0) {
                    setDefaultListOrderMinMax(listByFactoryAndMaterialGroup.map(rate => ({
                        id: rate.id,
                        min: rate.orderMin as number,
                        max: rate.orderMax as number,
                        rateDefault: rate.rate as number,
                        rate: rate.rate as number
                    })))
                    return;
                }

                listByFactoryOnly = rateDefaults.filter(
                    rate => rate.factoryId === factory && rate.costElementId === costElement && rate.formulaOptionId === formula && isValidDateRange(rate)
                );

                if (listByFactoryOnly.length > 0) {
                    setDefaultListOrderMinMax(listByFactoryOnly.map(rate => ({
                        id: rate.id,
                        min: rate.orderMin as number,
                        max: rate.orderMax as number,
                        rateDefault: rate.rate as number,
                        rate: rate.rate as number
                    })))
                    return;
                }

                setDefaultListOrderMinMax([])
                return;
            case 9:
                listByFactoryAndMaterialGroup = rateDefaults.filter(
                    rate => rate.factoryId === factory && rate.costElementId === costElement && rate.formulaOptionId === formula && rate.materialGroupId !== null && isValidDateRange(rate)
                );

                if (listByFactoryAndMaterialGroup.length > 0) {
                    setDefaultListOrderMinMaxColor(listByFactoryAndMaterialGroup.map(rate => ({
                        id: rate.id,
                        color: rate.color,
                        min: rate.orderMin as number,
                        max: rate.orderMax as number,
                        rateDefault: rate.rate as number,
                        rate: rate.rate as number
                    })))
                    return;
                }

                listByFactoryOnly = rateDefaults.filter(
                    rate => rate.factoryId === factory && rate.costElementId === costElement && rate.formulaOptionId === formula && isValidDateRange(rate)
                );

                if (listByFactoryOnly.length > 0) {
                    setDefaultListOrderMinMaxColor(listByFactoryOnly.map(rate => ({
                        id: rate.id,
                        color: rate.color,
                        min: rate.orderMin as number,
                        max: rate.orderMax as number,
                        rateDefault: rate.rate as number,
                        rate: rate.rate as number
                    })))
                    return;
                }

                setDefaultListOrderMinMaxColor([])
                return;
        }
    };



    const rateInputDefault = (
        <div className="field col-1">
            <Controller
                name="rateDefault"
                control={formCE.control}
                defaultValue={selectedRateDefault?.rate}
                render={({ field, fieldState }) => (
                    <>
                        <label htmlFor={field.name} className="font-bold text-xs">$ Default Rate</label>
                        <InputNumber
                            id={field.name}
                            inputRef={field.ref}
                            value={selectedRateDefault?.rate}
                            onBlur={field.onBlur}
                            min={0}
                            disabled
                            inputClassName={classNames({ 'p-invalid': fieldState.error })}
                            minFractionDigits={0} maxFractionDigits={3}
                        />
                    </>
                )}
            />
        </div>
    );
    const rateInput = (
        <div className="field col-1">
            <Controller
                name="rate"
                control={formCE.control}
                defaultValue={selectedRateDefault?.rate}
                rules={{
                    required: 'Rate is required.',
                    validate: (value) => {
                        if (value < 0 || value > 9999999999.9999) {
                            return 'Must be between 0 and 9.999.999.999.9999';
                          }
                        return true;
                      },
                }}
                render={({ field, fieldState }) => (
                    <>
                        <label htmlFor={field.name} className="font-bold text-xs">$ Rate *</label>
                        <InputNumber
                            id={field.name}
                            inputRef={field.ref}
                            value={selectedRateDefault?.rate}
                            onBlur={field.onBlur}
                            useGrouping={false}
                            onChange={(e) => field.onChange(e.value)}
                            onKeyDown={handleKeyDown}
                            inputClassName={classNames({ 'p-invalid border-left-10': fieldState.error })}
                            maxFractionDigits={4}
                        />
                        {getErrorMessage('rate')}
                    </>
                )}
            />
        </div>
    );

    const minutesInput = (
        <div className="field col-1">
            <Controller
                name="minutes"
                control={formCE.control}
                defaultValue={selectedRateDefault?.minutes}
                rules={{
                    required: 'Sublimation minutes are required.',
                    validate: (value) => (value >= 0) || 'Enter a valid number.'
                }}
                render={({ field, fieldState }) => (
                    <>
                        <label htmlFor={field.name} className="font-bold text-xs">Sub Minutes *</label>
                        <InputNumber
                            id={field.name}
                            inputRef={field.ref}
                            value={selectedRateDefault?.minutes}
                            onBlur={field.onBlur}
                            min={0}
                            onChange={(e) => field.onChange(e.value)}
                            inputClassName={classNames({ 'p-invalid border-left-10': fieldState.error })}
                            minFractionDigits={0} maxFractionDigits={3}
                        />
                        {getErrorMessage('minutes')}
                    </>
                )}
            />
        </div>
    );

    const handleCellEditCompleteSize = (e: ColumnEvent) => {
        e.rowData[e.field] = e.newValue;

        setSelectedSizes((currentSelectedSizes) => {
            // If currentSelectedSizes is null, return an empty array
            if (!currentSelectedSizes) {
                return [];
            }

            const rowIndex = currentSelectedSizes.findIndex(row => row.id === e.rowData.id);

            // If the row is found, update it
            if (rowIndex > -1) {
                const updatedSelectedSizes = [...currentSelectedSizes];
                updatedSelectedSizes[rowIndex] = e.rowData;
                return updatedSelectedSizes;
            }

            return currentSelectedSizes;
        });
    };

    const listLetterSize = (
        <div className="field col-2">
            <label htmlFor={"defaultSizes"} className="font-bold text-xs">Sizes *</label>
            <Button label="Select.." severity="secondary" name='defaultSizes' type='button' outlined onClick={(e) => op.current?.toggle(e)}></Button>
            {selectedSizes ? (
                <>
                    {selectedSizes.map((d, index) => (
                        <React.Fragment key={index}>
                            <small className="text-primary">
                                {`${d.value}" - $${d.rate}`}
                            </small>
                            <br />
                        </React.Fragment>
                    ))}
                </>
            ) : null}
            <OverlayPanel ref={op} showCloseIcon dismissable={false}>
                <Button size="small" className='mb-2' icon="pi pi-plus" severity="success" onClick={addNew} />

                <DataTable selectOnEdit={false} value={defaultListSizeColors} selectionMode={'checkbox'} selection={selectedSizes ?? []} onSelectionChange={(e) => { setSelectedSizes(e.value as ValueRate[]); }}>
                    <Column selectionMode="multiple"></Column>
                    <Column field="value" header="Size" editor={(options) => <InputNumber value={options.value} onChange={(e) => {
                        // Check if the new value is null or undefined or 0
                        if (e.value !== null && e.value !== undefined && e.value !== 0) {
                            (options.editorCallback ?? (() => { }))(e.value);
                        } else {
                            // Keep the previous value
                            (options.editorCallback ?? (() => { }))(options.value);
                        }
                    }} minFractionDigits={0} maxFractionDigits={3} />} onCellEditComplete={handleCellEditCompleteSize}></Column>
                    <Column field="rateDefault" header="Default Rate" editor={(options) => <InputNumber value={options.value} disabled minFractionDigits={0} maxFractionDigits={3} />} onCellEditComplete={(e) => e.rowData[e.field] = e.newValue}></Column>
                    <Column field="rate" header="Rate" editor={(options) => <InputNumber value={options.value} onValueChange={(e) => {
                        // Check if the new value is null or undefined or 0
                        if (e.value !== null && e.value !== undefined && e.value !== 0) {
                            (options.editorCallback ?? (() => { }))(e.value);
                        } else {
                            // Keep the previous value
                            (options.editorCallback ?? (() => { }))(options.value);
                        }
                    }} minFractionDigits={0} maxFractionDigits={3} />} onCellEditComplete={handleCellEditCompleteSize}></Column>
                </DataTable>
            </OverlayPanel>
        </div>
    );

    const handleCellEditCompleteColor = (e: ColumnEvent) => {
        e.rowData[e.field] = e.newValue;

        setSelectedColors((currentSelectedColors) => {
            // If currentSelectedSizes is null, return an empty array
            if (!currentSelectedColors) {
                return [];
            }

            const rowIndex = currentSelectedColors.findIndex(row => row.id === e.rowData.id);

            // If the row is found, update it
            if (rowIndex > -1) {
                const updatedSelectedColors = [...currentSelectedColors];
                updatedSelectedColors[rowIndex] = e.rowData;
                return updatedSelectedColors;
            }

            return currentSelectedColors;
        });
    };

    const listLetterColor = (
        <div className="field col-2">
            <label htmlFor={"defaultColors"} className="font-bold text-xs">Colors *</label>
            <Button label="Select.." severity="secondary" name='defaultColors' type='button' outlined onClick={(e) => op.current?.toggle(e)}></Button>
            {selectedColors ? (
                <>
                    {selectedColors.map((d, index) => (
                        <React.Fragment key={index}>
                            <small className="text-primary">
                                {`${d.value} - $${d.rate}`}
                            </small>
                            <br />
                        </React.Fragment>
                    ))}
                </>
            ) : null}
            <OverlayPanel ref={op} showCloseIcon dismissable={false}>
                <Button size="small" className='mb-2' icon="pi pi-plus" severity="success" onClick={addNew} />

                <DataTable selectOnEdit={false} value={defaultListSizeColors} selectionMode={'checkbox'} selection={selectedColors ?? []} onSelectionChange={(e) => { setSelectedColors(e.value as ValueRate[]) }}>
                    <Column selectionMode="multiple"></Column>
                    <Column field="value" header="Colors" editor={(options) => <InputNumber value={options.value} onValueChange={(e) => {
                        // Check if the new value is null or undefined or 0
                        if (e.value !== null && e.value !== undefined && e.value !== 0) {
                            (options.editorCallback ?? (() => { }))(e.value);
                        } else {
                            // Keep the previous value
                            (options.editorCallback ?? (() => { }))(options.value);
                        }
                    }} minFractionDigits={0} maxFractionDigits={3} />} onCellEditComplete={handleCellEditCompleteColor}></Column>
                    <Column field="rateDefault" header="Default Rate" editor={(options) => <InputNumber value={options.value} disabled minFractionDigits={0} maxFractionDigits={3} />} onCellEditComplete={(e) => e.rowData[e.field] = e.newValue}></Column>
                    <Column field="rate" header="Rate" editor={(options) => <InputNumber value={options.value} onValueChange={(e) => {
                        // Check if the new value is null or undefined or 0
                        if (e.value !== null && e.value !== undefined && e.value !== 0) {
                            (options.editorCallback ?? (() => { }))(e.value);
                        } else {
                            // Keep the previous value
                            (options.editorCallback ?? (() => { }))(options.value);
                        }
                    }} minFractionDigits={0} maxFractionDigits={3} />} onCellEditComplete={handleCellEditCompleteColor}></Column>
                </DataTable>
            </OverlayPanel>
        </div>
    );

    const handleCellEditCompleteMinMax = (e: ColumnEvent) => {
        e.rowData[e.field] = e.newValue;

        setSelectedOrderMinMax((currentSelectedMinMax) => {
            // If currentSelectedSizes is null, return an empty array
            if (!currentSelectedMinMax) {
                return [];
            }

            const rowIndex = currentSelectedMinMax.findIndex(row => row.id === e.rowData.id);

            // If the row is found, update it
            if (rowIndex > -1) {
                const updatedSelectedMinMax = [...currentSelectedMinMax];
                updatedSelectedMinMax[rowIndex] = e.rowData;
                return updatedSelectedMinMax;
            }

            return currentSelectedMinMax;
        });
    };

    const listOrderMinMax = (
        <div className="field col-2">
            <label htmlFor={"defaultOrderMinMax"} className="font-bold text-xs">Order Qty *</label>
            <Button label="Select.." severity="secondary" name='defaultOrderMinMax' type='button' outlined onClick={(e) => op.current?.toggle(e)}></Button>
            {selectedOrderMinMax ? (
                <>
                    {selectedOrderMinMax.map((d, index) => (
                        <React.Fragment key={index}>
                            <small className="text-primary">
                                {`${d.min} - ${d.max} - $${d.rate}`}
                            </small>
                            <br />
                        </React.Fragment>
                    ))}
                </>
            ) : null}
            <OverlayPanel ref={op} showCloseIcon dismissable={false}>
                <Button size="small" className='mb-2' icon="pi pi-plus" severity="success" onClick={addNewTwo} />

                <DataTable selectOnEdit={false} value={defaultListOrderMinMax} selectionMode={'checkbox'} selection={selectedOrderMinMax ?? []} onSelectionChange={(e) => { setSelectedOrderMinMax(e.value as TwoValueRate[]) }}>
                    <Column selectionMode="multiple"></Column>
                    <Column field="min" header="Min" editor={(options) => <InputNumber value={options.value} onValueChange={(e) => {
                        // Check if the new value is null or undefined or 0
                        if (e.value !== null && e.value !== undefined && e.value !== 0) {
                            (options.editorCallback ?? (() => { }))(e.value);
                        } else {
                            // Keep the previous value
                            (options.editorCallback ?? (() => { }))(options.value);
                        }
                    }} minFractionDigits={0} maxFractionDigits={3} />} onCellEditComplete={handleCellEditCompleteMinMax}></Column>
                    <Column field="max" header="Max" editor={(options) => <InputNumber value={options.value} onValueChange={(e) => {
                        // Check if the new value is null or undefined or 0
                        if (e.value !== null && e.value !== undefined && e.value !== 0) {
                            (options.editorCallback ?? (() => { }))(e.value);
                        } else {
                            // Keep the previous value
                            (options.editorCallback ?? (() => { }))(options.value);
                        }
                    }} minFractionDigits={0} maxFractionDigits={3} />} onCellEditComplete={handleCellEditCompleteMinMax}></Column>
                    <Column field="rateDefault" header="Default Rate" editor={(options) => <InputNumber value={options.value} disabled minFractionDigits={0} maxFractionDigits={3} />} onCellEditComplete={(e) => e.rowData[e.field] = e.newValue}></Column>
                    <Column field="rate" header="Rate" editor={(options) => <InputNumber value={options.value} onValueChange={(e) => {
                        // Check if the new value is null or undefined or 0
                        if (e.value !== null && e.value !== undefined && e.value !== 0) {
                            (options.editorCallback ?? (() => { }))(e.value);
                        } else {
                            // Keep the previous value
                            (options.editorCallback ?? (() => { }))(options.value);
                        }
                    }} minFractionDigits={0} maxFractionDigits={3} />} onCellEditComplete={handleCellEditCompleteMinMax}></Column>
                </DataTable>
            </OverlayPanel>
        </div>
    );

    const handleCellEditCompleteMinMaxColor = (e: ColumnEvent) => {
        e.rowData[e.field] = e.newValue;

        setSelectedOrderMinMaxColor((currentSelectedMinMaxColor) => {
            // If currentSelectedSizes is null, return an empty array
            if (!currentSelectedMinMaxColor) {
                return [];
            }

            const rowIndex = currentSelectedMinMaxColor.findIndex(row => row.id === e.rowData.id);

            // If the row is found, update it
            if (rowIndex > -1) {
                const updatedSelectedMinMaxColor = [...currentSelectedMinMaxColor];
                updatedSelectedMinMaxColor[rowIndex] = e.rowData;
                return updatedSelectedMinMaxColor;
            }

            return currentSelectedMinMaxColor;
        });
    };
    const listOrderMinMaxColor = (
        <div className="field col-2">
            <label htmlFor={"defaultOrderMinMaxColor"} className="font-bold text-xs">Color / Order Qty *</label>
            <Button label="Select.." severity="secondary" name='defaultOrderMinMaxColor' type='button' outlined onClick={(e) => op.current?.toggle(e)}></Button>
            {selectedOrderMinMaxColor ? (
                <>
                    {selectedOrderMinMaxColor.map((d, index) => (
                        <React.Fragment key={index}>
                            <small className="text-primary">
                                {`${d.color} - ${d.min} - ${d.max} - $${d.rate}`}
                            </small>
                            <br />
                        </React.Fragment>
                    ))}
                </>
            ) : null}
            <OverlayPanel ref={op} showCloseIcon dismissable={false}>
                <Button size="small" className='mb-2' icon="pi pi-plus" severity="success" onClick={addNewThree} />

                <DataTable selectOnEdit={false} value={defaultListOrderMinMaxColor} selectionMode={'checkbox'} selection={selectedOrderMinMaxColor ?? []} onSelectionChange={(e) => { setSelectedOrderMinMaxColor(e.value as ThreeValueRate[]) }}>
                    <Column selectionMode="multiple"></Column>
                    <Column field="color" header="Color" editor={(options) => <InputText value={options.value} onChange={(e) => (options.editorCallback ?? (() => { }))(e.target.value)} />} onCellEditComplete={(e) => e.rowData[e.field] = e.newValue}></Column>
                    <Column field="min" header="Min" editor={(options) => <InputNumber value={options.value} onValueChange={(e) => {
                        // Check if the new value is null or undefined or 0
                        if (e.value !== null && e.value !== undefined && e.value !== 0) {
                            (options.editorCallback ?? (() => { }))(e.value);
                        } else {
                            // Keep the previous value
                            (options.editorCallback ?? (() => { }))(options.value);
                        }
                    }} minFractionDigits={0} maxFractionDigits={3} />} onCellEditComplete={handleCellEditCompleteMinMaxColor}></Column>
                    <Column field="max" header="Max" editor={(options) => <InputNumber value={options.value} onValueChange={(e) => {
                        // Check if the new value is null or undefined or 0
                        if (e.value !== null && e.value !== undefined && e.value !== 0) {
                            (options.editorCallback ?? (() => { }))(e.value);
                        } else {
                            // Keep the previous value
                            (options.editorCallback ?? (() => { }))(options.value);
                        }
                    }} minFractionDigits={0} maxFractionDigits={3} />} onCellEditComplete={handleCellEditCompleteMinMaxColor}></Column>
                    <Column field="rateDefault" header="Default Rate" editor={(options) => <InputNumber value={options.value} disabled minFractionDigits={0} maxFractionDigits={3} />} onCellEditComplete={(e) => e.rowData[e.field] = e.newValue}></Column>
                    <Column field="rate" header="Rate" editor={(options) => <InputNumber value={options.value} onValueChange={(e) => {
                        // Check if the new value is null or undefined or 0
                        if (e.value !== null && e.value !== undefined && e.value !== 0) {
                            (options.editorCallback ?? (() => { }))(e.value);
                        } else {
                            // Keep the previous value
                            (options.editorCallback ?? (() => { }))(options.value);
                        }
                    }} minFractionDigits={0} maxFractionDigits={3} />} onCellEditComplete={handleCellEditCompleteMinMaxColor}></Column>
                </DataTable>
            </OverlayPanel>
        </div>
    );

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === '.') {
            const inputElem = e.target as HTMLInputElement;
            if (inputElem.value === '' || inputElem.value === null) {
                inputElem.value = '0.';
                e.preventDefault();
            }
        }
    };

    const exportRateDefaults = () => {
        let originalRateDefaultData = [...dtRD.current.props.value];

        if (styleCode === undefined) { return; }
        BomCostingService.getRateDefaultByMaterialGroup(styleCode).then((data: RateDefault[]) => {
            dtRD.current.props.value = data;
            dtRD.current.exportCSV();
        });

        dtRD.current.props.value = originalRateDefaultData;
    };

    const exportStyleCostElements = () => {
        let originalRateDefaultData = [...dtCE.current.props.value];

        if (styleCode === undefined) { return; }
        BomCostingService.getAllStyleCostConfigurationsByStyle(styleCode).then((data: StyleCostConfiguration[]) => {
            dtCE.current.props.value = data;
            dtCE.current.exportCSV();
        });
        dtCE.current.props.value = originalRateDefaultData;
    };

    const onFilter = (event: DataTableFilterEvent) => {
        event['filter'] = globalFilterRD;
    };

    const onFilterCE = (event: DataTableFilterEvent) => {
        event['filter'] = globalFilterCE;
    };

    const headerRateDefault = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <i className="pi pi-file-excel ml-3 text-green-500 cursor-pointer" title="Export" onClick={(e) => { exportRateDefaults(); e.stopPropagation(); }} />
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" onInput={(e) => {
                    setGlobalFilterRD((e.target as HTMLInputElement).value);
                }} placeholder="Search..." />
            </IconField>
        </div>
    );

    const headerStyleCostElement = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <i className="pi pi-file-excel ml-3 text-green-500 cursor-pointer" title="Export" onClick={(e) => { exportStyleCostElements(); e.stopPropagation(); }} />
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" onInput={(e) => {
                    setGlobalFilterCE((e.target as HTMLInputElement).value);
                }} placeholder="Search..." />
            </IconField>            
        </div>
    );
    return (
        <div>
            <Toast ref={toastRD} />

            <Panel header="Add Cost Element" className="addPanel mb-2 -ml-2">
                <form onSubmit={formCE.handleSubmit(onSubmitCostElements)} className="p-fluid" autoComplete="off">
                    <div className="formgrid grid">
                        <div className="field col-fixed">
                            <Controller
                                name="costElementId"
                                control={formCE.control}
                                rules={{ required: 'Cost Element is required.' }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Cost Element *</label>
                                        <Dropdown inputId={field.name} value={field.value} options={costElements} optionLabel="description" optionValue="id" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value); setSelectedCostElement(e.value); resetFollowingFields('costElementId'); }} filter filterBy="description" placeholder="Select..." virtualScrollerOptions={{ itemSize: 50 }} />
                                        {getErrorMessage('costElementId')}
                                    </>
                                )}
                            />
                        </div>
                        {selectedCostElement != null && (
                            <div className="field col-fixed">
                                <Controller
                                    name="factoryId"
                                    control={formCE.control}
                                    rules={{ required: 'Plant/Vendor is required.' }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Plant/Vendor *</label>
                                            <Dropdown inputId={field.name} value={field.value} options={factories.filter(factory => factory.sapReference !== null && factory.sapReference !== undefined && factory.sapReference !== '')} optionLabel="sapReference" optionValue="id" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                                onChange={(e) => { field.onChange(e.value); setSelectedFactory(e.value); resetFollowingFields('factoryId'); }} filter filterBy="sapReference" placeholder="Select..." />
                                            {(field.value !== null && field.value !== undefined) ? <small className="text-primary">{factories.find(ce => ce.id === field.value)?.description}</small> : <></>}
                                            {getErrorMessage('factoryId')}
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        {selectedFactory != null && (
                            <div className="field col-fixed">
                                <Controller
                                    name="formulaOptionId"
                                    control={formCE.control}
                                    rules={{ required: 'Formula Option is required.' }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Formula Option *</label>
                                            <Dropdown
                                                inputId={field.name}
                                                value={field.value}
                                                options={formulaOptions}
                                                optionLabel="optionName"
                                                optionValue="id"
                                                className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                                onChange={(e) => {
                                                    field.onChange(e.value); setSelectedFormula(e.value); resetFollowingFields('formulaOptionId');
                                                    findBestRate(e.value, selectedCostElement, selectedFactory);
                                                }}
                                                showClear
                                                placeholder="Select..."
                                            />
                                            {getErrorMessage('formulaOptionId')}
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        {selectedFormula !== null && [5, 10].includes(selectedFormula) && listLetterSize}
                        {selectedFormula !== null && [6].includes(selectedFormula) && listLetterColor}
                        {selectedFormula !== null && [7].includes(selectedFormula) && listOrderMinMax}
                        {selectedFormula !== null && [9].includes(selectedFormula) && listOrderMinMaxColor}


                        {selectedFormula !== null && [0, 1, 2, 3, 4, 8].includes(selectedFormula) && rateInputDefault}
                        {selectedFormula !== null && [0, 1, 2, 3, 4, 8].includes(selectedFormula) && rateInput}

                        {selectedFormula !== null && [2, 3].includes(selectedFormula) && minutesInput}

                        {selectedFormula !== null && selectedFormula > 0 && (
                            <div className="field col-1">
                                <Controller
                                    name="minChargeUnit"
                                    control={formCE.control}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">$ Min / Unit</label>
                                            <InputNumber
                                                id={field.name}
                                                inputRef={field.ref}
                                                value={field.value}
                                                onBlur={field.onBlur}
                                                min={0}
                                                onChange={(e) => field.onChange(e.value)}
                                                inputClassName={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                                minFractionDigits={0} maxFractionDigits={3}
                                            />
                                            {getErrorMessage('minChargeUnit')}
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        {selectedFormula !== null && selectedFormula > 0 && (
                            <div className="field col-1">
                                <Controller
                                    name="minChargeCostElement"
                                    control={formCE.control}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">$ Min / Elem</label>
                                            <InputNumber
                                                id={field.name}
                                                inputRef={field.ref}
                                                value={field.value}
                                                onBlur={field.onBlur}
                                                min={0}
                                                onChange={(e) => field.onChange(e.value)}
                                                inputClassName={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                                minFractionDigits={0} maxFractionDigits={3}
                                            />
                                            {getErrorMessage('minChargeCostElement')}
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        {selectedFormula != null && selectedFormula >= 0 && (
                            <div className="field col">
                                <Controller
                                    name="effectiveDate"
                                    control={formCE.control}
                                    rules={{
                                        required: 'Effective date is required'
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Effective Date *</label>
                                            <Calendar id={field.name} name={field.name} value={field.value} minDate={new Date()} inputClassName={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e: FormEvent<Date, SyntheticEvent<Element, Event>>) => field.onChange(e.target.value)} dateFormat="yy-mm-dd" placeholder="Effective" />
                                            {getErrorMessage('effectiveDate')}
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        {selectedFormula != null && selectedFormula >= 0 && (
                            <div className="field col">
                                <Controller
                                    name="expirationDate"
                                    control={formCE.control}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Expiration Date</label>
                                            <Calendar id={field.name} name={field.name} value={field.value} minDate={new Date()} onChange={(e: FormEvent<Date, SyntheticEvent<Element, Event>>) => field.onChange(e.target.value)} dateFormat="yy-mm-dd" placeholder="Expiration" />
                                        </>
                                    )}
                                />
                            </div>
                        )}

                        <div className="field field-buttons col pt-4">
                            <Button icon="pi pi-save" title="Save" rounded text severity="info" type="submit" />
                            <Button icon="pi pi-undo" title="Undo" rounded text severity="danger" type="button" onClick={clearNew} />
                        </div>
                    </div>
                </form>
            </Panel>

            <Card className="-ml-2 mt-2">
                <DataTable ref={dtCE} value={styleCostConfigurations} className="-ml-2" dataKey="id" size="small" loading={loadingStyleCostConfiguration} header={headerStyleCostElement} globalFilter={globalFilterCE}
                    onFilter={onFilterCE}
                    emptyMessage="No cost elements found.">
                    <Column field="styleCd" header="Style Code" style={{ display: 'none' }}></Column>
                    <Column field="costElementId" header="Cost Element" body={costElementIdBodyTemplate} align="center" alignHeader="center" exportable={false}></Column>
                    <Column field="costElementDescription" header="Cost Element" style={{ display: 'none' }}></Column>
                    <Column field="factoryId" header="Plant/Vendor" body={factoryIdBodyTemplate} align="center" alignHeader="center" exportable={false}></Column>
                    <Column field="sapReference" header="Plant/Vendor" style={{ display: 'none' }}></Column>
                    <Column field="formulaOptionId" header="Formula" body={formulaOptionIdBodyTemplate} align="center" alignHeader="center" exportable={false}></Column>
                    <Column field="formulaOptionName" header="Formula" style={{ display: 'none' }}></Column>
                    <Column field="letterSize" header="Letter Size" body={letterSizeBodyTemplate} align="center" alignHeader="center"></Column>
                    <Column field="numberOfColors" header="Colors" body={numberOfColorsBodyTemplate} align="center" alignHeader="center"></Column>
                    <Column field="color" header="Color" body={colorBodyTemplate} align="center" alignHeader="center"></Column>
                    <Column field="orderMin" header="Min Quantity" body={orderMinBodyTemplate} align="center" alignHeader="center"></Column>
                    <Column field="orderMax" header="Max Quantity" body={orderMaxBodyTemplate} align="center" alignHeader="center"></Column>
                    <Column field="rate" header="Rate" body={rateBodyTemplate} align="center" alignHeader="center"></Column>
                    <Column field="effectiveDate" header="Effective" body={effectiveDateBodyTemplate} style={{ width: '100px' }} align="center" alignHeader="center"></Column>
                    <Column field="expirationDate" header="Expiration" body={expirationDateBodyTemplate} style={{ width: '100px' }} align="center" alignHeader="center"></Column>
                    <Column field="minChargeUnit" header="Min Charge / Unit" body={minChargeUnitBodyTemplate} align="center" alignHeader="center"></Column>
                    <Column field="minChargeCostElement" header="Min Charge / Element" body={minChargeCostElementBodyTemplate} align="center" alignHeader="center"></Column>
                    <Column field="workCenterId" header="Work Center" body={workCenterIdBodyTemplate} align="center" alignHeader="center" exportable={false}></Column>
                    <Column field="workCenterCode" header="Work Center" style={{ display: 'none' }}></Column>
                    <Column field="minutes" header="Minutes" body={minutesBodyTemplate} align="center" alignHeader="center"></Column>
                    <Column rowEditor body={rowEditorTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
                </DataTable>
            </Card>

            <Card className="-ml-2 mt-2" title="Rate Defaults">
                <DataTable ref={dtRD} value={rateDefaultsMaterialGroup} header={headerRateDefault} dataKey="id" size="small" loading={loadingRateDefaultsMaterialGroup} globalFilter={globalFilterRD}
                    onFilter={onFilter}
                    emptyMessage="No cost elements found.">
                    <Column field="styleCd" header="Style Code" style={{ display: 'none' }}></Column>
                    <Column field="costElementId" header="Cost Element" body={costElementIdTemplateRD} align="center" alignHeader="center" exportable={false} ></Column>
                    <Column field="costElementDescription" header="Cost Element" style={{ display: 'none' }}></Column>
                    <Column field="factoryId" header="Plant/Vendor" body={factoryIdTemplateRD} align="center" alignHeader="center" exportable={false}></Column>
                    <Column field="sapReference" header="Plant/Vendor" style={{ display: 'none' }}></Column>
                    <Column field="formulaOptionId" header="Formula" body={formulaOptionIdTemplateRD} style={{ width: '100px' }} align="center" alignHeader="center" exportable={false} ></Column>
                    <Column field="formulaOptionName" header="Formula" style={{ display: 'none' }}></Column>
                    <Column field="letterSize" header="Letter Size" body={letterSizeTemplateRD} align="center" style={{ width: '5px' }} alignHeader="center" ></Column>
                    <Column field="numberOfColors" header="Colors" body={numberOfColorsTemplateRD} align="center" alignHeader="center" ></Column>
                    <Column field="color" header="Color" body={colorTemplateRD} align="center" alignHeader="center" ></Column>
                    <Column field="orderMin" header="Min Quantity" body={orderMinTemplateRD} align="center" style={{ width: '5px' }} alignHeader="center" ></Column>
                    <Column field="orderMax" header="Max Quantity" body={orderMaxTemplateRD} align="center" style={{ width: '5px' }} alignHeader="center" ></Column>
                    <Column field="rate" header="Rate" body={rateTemplateRD} align="center" alignHeader="center"></Column>
                    <Column field="effectiveDate" header="Effective" body={effectiveDateTemplateRD} style={{ width: '100px' }} align="center" alignHeader="center" ></Column>
                    <Column field="expirationDate" header="Expiration" body={expirationDateTemplateRD} style={{ width: '100px' }} align="center" alignHeader="center"></Column>
                    <Column field="minChargeUnit" header="Min Charge / Unit" body={minChargeUnitBodyTemplateRD} align="center" alignHeader="center"></Column>
                    <Column field="minChargeCostElement" header="Min Charge / Element" body={minChargeCostElementBodyTemplateRD} align="center" alignHeader="center"></Column>
                    <Column field="workCenterId" header="Work Center" body={workCenterIdBodyTemplateRD} align="center" alignHeader="center" exportable={false}></Column>
                    <Column field="workCenterCode" header="Work Center" style={{ display: 'none' }}></Column>
                    <Column field="minutes" header="Minutes" body={minutesBodyTemplateRD} align="center" alignHeader="center"></Column>
                </DataTable>
            </Card>

            <Dialog visible={deleteDialogCE} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteDialogFooterCE} onHide={hideDeleteDialogCE}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {styleCostConfiguration && (
                        <span>
                            Are you sure you want to delete <b>{costElements.find(wc => wc.id === styleCostConfiguration.costElementId)?.description}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
        </div>
    )
}

export default StyleCostElements;